<template>
  <pp-modal
    v-model="showModal"
    :mask-closable="false"
    fullscreen
    :transfer="false"
    width="450"
    :closable="false">
    <div class="modalhead">
      <div class="">流水详情</div>
      <div class="secondTitle">{{fundFlowId}}</div>
    </div>
    <div class="content">
      <div class="line">
        <div class="fl">业务类型</div>
        <div class="fr">{{this.$filters.getFondTypeName(fundType)}}</div>
      </div>
      <div class="line">
        <div class="fl">交易流水号</div>
        <div class="fr">{{transactionId}}</div>
      </div>
      <div v-if="fundType=='DEPOSIT_REFUND'" class="line">
        <div class="fl">相关退款流水</div>
        <div class="fr">{{flowId}}</div>
      </div>

      <div class="line">
        <div class="fl" v-if="fundType=='DEPOSIT'">持有金额</div>
        <div class="fl" v-if="fundType!='DEPOSIT'">返还金额</div>
        <div class="fr" v-if="fundType=='DEPOSIT'">{{this.$filters.money(creditAmount)}} {{currency}}</div>
        <div class="fr" v-if="fundType!='DEPOSIT'">{{this.$filters.money(debitAmount)}} {{currency}}</div>
      </div>
      <div class="line">
        <div class="fl" v-if="fundType=='DEPOSIT'">持有时间</div>
        <div class="fl" v-if="fundType!='DEPOSIT'">返还时间</div>
        <div class="fr">{{this.$filters.timestampToDatetime(created)}}</div>
      </div>
    </div>
    <div slot="footer" class="textright">
      <pp-button class="modal-btn" type="primary" size="spec" @click="sure">确认</pp-button>
    </div>
  </pp-modal>

</template>
<script>
  export default {
    name: 'flowDetailModal',
    props: {},
    mounted() {
    },
    data() {
      return {
        showModal: false,
        fundFlowId: '',
        fundType: '',
        currency: '',
        availableBalance: '',
        created: '',
        accountNo: '',
        flowId: '',
        transactionId: '',
        creditAmount: '',
        debitAmount: ''

      }
    },
    methods: {
      sure() {
        this.showModal = false
      },
      show(params) {
        this.flowId = params.flowId
        this.fundFlowId = params.fundFlowId
        this.fundType = params.fundType
        this.transactionId = params.transactionId
        this.currency = params.currency
        this.creditAmount = params.creditAmount
        this.debitAmount = params.debitAmount
        this.created = params.created
        this.showModal = true
      }
    }
  }
</script>
<style lang="scss" scoped>
  .modalhead {
    display: block;
    width: 100%;
    height: 60px;
    line-height: 30px;
    font-size: 20px;
    color: #1c2438;
    font-weight: 400;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap
  }

  .textright .modal-btn {
    padding: 6px 20px;
    height: 32px;
    text-align: center;
    font-size: 14px;
  }

  .secondTitle {
    color: #000;
    font-size: 14px;
    height: 18px;
    line-height: 18px;
    text-align: left;
    filter: alpha(opacity=56);
    -moz-opacity: 0.56;
    -khtml-opacity: 0.56;
    opacity: 0.56;
    margin-bottom: 4px;
  }

  .modalContent {
    text-align: left;
    font-size: 14px;
  }

  .content {
    width: 100%;

    .line {
      height: 20px;
      font-size: 14px;
      line-height: 20px;
      margin-top: 16px;
    }

    .bankline {
      margin-top: 16px;
      height: 70px;

      img {
        float: left;
        display: block;
        width: 64px;
        height: 64px;
      }

      .info {
        height: 64px;
        float: left;
        margin: 0 0 0 41px;

        div {
          height: 32px;
          line-height: 32px;
        }
      }

    }
  }


</style>
